import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import ContactUs from './pages/ContactUs';
import About from './pages/About';
import Footer from './pages/Footer';
import PatientNormothermia from './pages/PatientNormothermia';
import Warmingunit from './pages/Wallabies Forced Air Patient Warming Unit';
import Productwallabies from './pages/PRODUCT WALLABIES WARM AIR BLANKETS';
import Instruction from './pages/Instruction';
import Cleanroom from './pages/Clean Room';
import Gallery from './pages/Gallery';
import YouTubeEmbed from './pages/Videos';
import Downloadbrochure from './pages/Download Brochure';
import Warmermanual from './pages/Warmer Manual';
import Enquiry from './pages/Enquiry';
import Patientforcedairpune from './pages/Patient Forced Air Warming System in Pune';
import Patientforcedairwarmingdelhi from './pages/Patient Forced Air Warming Blankets in Delhi';
import ScrollToTop from './components/ScrollToTop';
import Forcedwarmermumbai from './pages/Patient Forced Air Warmer in Mumbai';
import Patientwarningsystem from './pages/Patient Warming Systems in Chennai';
import Patientwarmerinbanglore from './pages/Patient Warmer in Bengaluru';
import Normothermiaequipment from './pages/Normothermia Equipment in Hyderabad';
import Systeminahmedabad from './pages/Thermoregulation System in Ahmedabad';
import Deviceinkolkata from './pages/Patient Warming Devices in Kolkata';
import Patientwarmiajaipur from './pages/Patient Warming Blankets in Jaipur';
import Patientforcedsurat from './pages/Patient Forced Air Warming System in Surat';
import Forcedaircoimbotore from './pages/Forced Air Warming Blankets in Coimbatore';
import Thermorgulationsystem from './pages/Thermoregulation Systems in Indore';
import Patientwarmingblanketslucknow from './pages/Patient Warming Blankets in Lucknow';
import Patientforcedwarmerchandighad from './pages/Patient Forced Air Warmer in Chandigarh';
import Patientwarmingsysteminpatna from './pages/Patient Warming Systems in Patna';
import Warminsystemhyderabad from './pages/Patient Forced Air Warming System in Hyderabad';
import Delhincr from './pages/Patient forced air warming blankets in Delhi NCR';
import Forcedairwarmingsysteminnoida from './pages/Forced Air Warming System in Noida';
import Patientwarmingdeviceinbhopal from './pages/Patient Warming Devices in Bhopal';
import Warmingkochi from './pages/Patient Warming Blankets in Kochi';
import Warmingsystempune from './pages/Patient Warming System in Pune';
import Warmingblanketbanglore from './pages/Forced Air Warming Blankets in Bengaluru';
import Devicechennai from './pages/Patient Warming Devices in Chennai';
import Systemsurat from './pages/Patient Thermoregulation System in Surat';
import Systemjaipur from './pages/Patient Forced Air Warming System in Jaipur';
import Devicemumbai from './pages/Patient Warming Devices in Mumbai';
import Warmerkolkata from './pages/Patient Forced Air Warmer in Kolkata';
import Coimbatoresystem from './pages/Forced Air Warming System in Coimbatore';
import Systemvadodara from './pages/Patient Warming Systems in Vadodara';
import Gurgaonequipment from './pages/Normothermia Equipment in Gurgaon';
import Ahemdabadwarmer from './pages/Patient Warmer in Ahmedabad';
import Lacknowblankets from './pages/Forced Air Warming Blankets in Lucknow';
import Systemchennai from './pages/Patient Thermoregulation System in Chennai';
import Chandigharhsystem from './pages/Patient Warming System in Chandigarh';
import Patientwarmingdeviceindore from './pages/Patient Warming Devices in Indore';
import Blanketsmumbai from './pages/Patient Warming Blankets in Mumbai';
import Warmerdelhi from './pages/Forced Air Warmer in Delh';
import Equipmentpatna from './pages/Normothermia Equipment in Patna';
import Systembenglore from './pages/Patient Thermoregulation System in Bengaluru';
import Systemkolkata from './pages/Patient Warming System in Kolkata';
import Systempune from './pages/Thermal Warming System for Patients in Pune';
import Warmingsystemdelhi from './pages/Patient Body Warming System in Delhi';
import Deviceinmumbai from './pages/Medical Patient Warming Devices in Mumbai';
import Systemchennairegulation from './pages/Body Temperature Regulation Systems in Chennai';
import Hospitalbenluru from './pages/Forced Air Warming Blankets for Hospitals in Bengaluru';
import Surgicslhyderabad from './pages/Warming Blankets for Surgical Use in Hyderabad';
import Devicepatientahemdabad from './pages/Temperature Management Devices for Patients in Ahmedabad';
import Kolkatasystem from './pages/Surgical Patient Warming Systems in Kolkata';
import Suratsystem from './pages/Patient Hypothermia Prevention System in Surat';
import TermsConditions from './pages/TermsConditions';
import PrivacyPolicy from './pages/PrivacyPolicy';
import ContactButtons from './components/ContactButtons';
import Patientbodywarmermanufacrul from './pages/Patient Body Warmer Manufacturers in India';
import Patientwarmerblanketmanu from './pages/Patient Warmer Blanket Manufacturers';
import Airforcewarmingsystem from './pages/Air Force Warning System in India';
import Convectionpatientwarmerblanket from './pages/Convection Patient Warmer Blanket Manufacturers';
import Systemmanufactures from './pages/Patient Warming System Manufacturers';
import Hypothermiaprevention from './pages/Hypothermia Prevention Machine Manufacturers';
import Patientwarmingmachinemanufacures from './pages/Patient Warming Machine Manufacturers in India';
import Bairhuggerwarming from './pages/3M Bair Hugger Warming Blanket';
import Bairhuggerwarmingmachine from './pages/Bair Hugger Warming Machine Manufacturer';
import Thermalwarmingsystem from './pages/Thermal Warming System for Patients in India';
import Cooconwarming from './pages/Cocoon Convective Patient Warming System';
import Airwarmermachinemanufacturesinindian from './pages/Air Warmer Machine Manufacturers in India';
import Mistralairblanketwarmer from './pages/Mistral Air Blanket Warmer Machine';
import Mistralairplusservice from './pages/Mistral Air Plus Service Warmer Machine';
import GAWrapper from './pages/GAWrapper';
import Patientionwarmingsystem from './pages/patient warming system';
import Patientwarminfdevice from './pages/Patient Warming Devices';
import Patientionwarmingblanket from './pages/Patient Warming Blanket';
import Patientionwarmingmachine from './pages/Patient Warming Machine';
import Patientionwarmingmattress from './pages/Patient Warming Mattress';
import Patientionwarmingsystemmanufacture from './pages/Patient Warming System Manufacturers in India';
import Patientionwarmingchecklist from './pages/Patient Warming Checklist';




function App() {
  return (
    <Router>
      <GAWrapper/>
      <ScrollToTop />
      <ContactButtons />
      <Header />


      <Routes>

        <Route path="/" element={<HeroSection />} />
        <Route path="/about" element={<About />} />
        <Route path="/term-condition" element={<TermsConditions />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/Wallabies-Forced-Air-Patient-Warming-Unit" element={<Warmingunit />} />
        <Route path="/wallabies-forced-air-patient-warming-blanket" element={<Productwallabies />} />
        <Route path="/Patient-thermoregulation-system" element={<PatientNormothermia />} />
        <Route path="/Instruction" element={<Instruction />} />
        <Route path="/Clean-room" element={<Cleanroom />} />
        <Route path="/Photos" element={<Gallery />} />
        <Route path="/Videos" element={<YouTubeEmbed />} />
        <Route path="/Download-Brochure" element={<Downloadbrochure />} />
        <Route path="/Warmer-Manual" element={<Warmermanual />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/enquiry" element={<Enquiry />} />
        <Route path="/Patient-Forced-Air-Warming-System-in-Pune" element={<Patientforcedairpune />} />
        <Route path="/Patient-Forced-Air-Warming-Blankets-in-Delhi" element={<Patientforcedairwarmingdelhi />} />
        <Route path="/Patient-Forced-Air-Warmer-in-Mumbai" element={<Forcedwarmermumbai />} />

        <Route path="/Patient-Warming-Systems-in-Chennai" element={<Patientwarningsystem />} />
        <Route path="/Patient-Warmer-in-Bengaluru" element={<Patientwarmerinbanglore />} />
        <Route path="/Normothermia-Equipment-in-Hyderabad" element={<Normothermiaequipment />} />
        <Route path="/Patient-Thermoregulation-System-in-Ahmedabad" element={<Systeminahmedabad />} />
        <Route path="/Patient-Warming-Devices-in-Kolkata" element={<Deviceinkolkata />} />
        <Route path="/Patient-Warming-Blankets-in-Jaipur" element={<Patientwarmiajaipur />} />
        <Route path="/Patient-Forced-Air-Warming-System-in-Surat" element={<Patientforcedsurat />} />
        <Route path="/Forced-Air-Warming-Blankets-in-Coimbatore" element={<Forcedaircoimbotore />} />
        <Route path="/Patient-Warming-Blankets-in-Lucknow" element={<Patientwarmingblanketslucknow />} />
        <Route path="/Patient-Forced-Air-Warmer-in-Chandigarh" element={<Patientforcedwarmerchandighad />} />
        <Route path="/Thermoregulation-Systems-in-Indore" element={<Thermorgulationsystem />} />
        <Route path="/Patient-Warming-Systems-in-Patna" element={<Patientwarmingsysteminpatna />} />
        <Route path="/Patient-Forced-Air-Warming-System-in-Hyderabad" element={<Warminsystemhyderabad />} />
        <Route path="/Patient-Forced-Air-Warming-Blankets-in-Delhi-NCR" element={<Delhincr />} />
        <Route path="/Forced-Air-Warming-System-in-Noida" element={<Forcedairwarmingsysteminnoida />} />
        <Route path="/Patient-Warming-Devices-in-Bhopal" element={<Patientwarmingdeviceinbhopal />} />

        <Route path="/Patient-Warming-Blankets-in-Kochi" element={<Warmingkochi />} />
        <Route path="/Patient-Warming-System-in-Pune" element={<Warmingsystempune />} />
        <Route path="/Forced-Air-Warming-Blankets-in-Bengaluru" element={<Warmingblanketbanglore />} />
        <Route path="/Patient-Warming-Devices-in-Chennai" element={<Devicechennai />} />
        <Route path="/Patient-Thermoregulation-System-in-Surat" element={<Systemsurat />} />
        <Route path="/Patient-Forced-Air-Warming-System-in-Jaipur" element={<Systemjaipur />} />
        <Route path="/Patient-Warming-Devices-in-Mumbai" element={<Devicemumbai />} />
        <Route path="/Patient-Forced-Air-Warmer-in-Kolkata" element={<Warmerkolkata />} />
        <Route path="/Forced-Air-Warming-System-in-Coimbatore" element={<Coimbatoresystem />} />
        <Route path="/Patient-Warming-Systems-in-Vadodara" element={<Systemvadodara />} />
        <Route path="/Normothermia-Equipment-in-Gurgaon" element={<Gurgaonequipment />} />
        <Route path="/Patient-Warmer-in-Ahmedabad" element={<Ahemdabadwarmer />} />
        <Route path="/Forced-Air-Warming-Blankets-in-Lucknow" element={<Lacknowblankets />} />
        <Route path="/Patient-Thermoregulation-System-in-Chennai" element={<Systemchennai />} />
        <Route path="/Patient-Warming-System-in-Chandigarh" element={<Chandigharhsystem />} />


        <Route path="/Patient-Warming-Devices-in-Indore" element={<Patientwarmingdeviceindore />} />
        <Route path="/Patient-Warming-Blankets-in-Mumbai" element={<Blanketsmumbai />} />
        <Route path="/Forced-Air-Warmer-in-Delhi" element={<Warmerdelhi />} />
        <Route path="/Normothermia-Equipment-in-Patna" element={<Equipmentpatna />} />
        <Route path="/Patient-Thermoregulation-System-in-Bengaluru" element={<Systembenglore />} />
        <Route path="/Patient-Warming-System-in-Kolkata" element={<Systemkolkata />} />
        <Route path="/Thermal-Warming-System-for-Patients-in-Pune" element={<Systempune />} />
        <Route path="/Patient-Body-Warming-System-in-Delhi" element={<Warmingsystemdelhi />} />
        <Route path="/Medical-Patient-Warming-Devices-in-Mumbai" element={<Deviceinmumbai />} />
        <Route path="/Body-Temperature-Regulation-Systems-in-Chennai" element={<Systemchennairegulation />} />
        <Route path="/Forced-Air-Warming-Blankets-for-Hospitals-in-Bengaluru" element={<Hospitalbenluru />} />
        <Route path="/Warming-Blankets-for-Surgical-Use-in-Hyderabad" element={<Surgicslhyderabad />} />
        <Route path="/Temperature-Management-Devices-for-Patients-in-Ahmedabad" element={<Devicepatientahemdabad />} />
        <Route path="/Surgical-Patient-Warming-Systems-in-Kolkata" element={<Kolkatasystem />} />
        <Route path="/Patient-Hypothermia-Prevention-System-in-Surat" element={<Suratsystem />} />



        <Route path="/Patient-Body-Warmer-Manufacturers-in-India" element={<Patientbodywarmermanufacrul />} />
        <Route path="/Patient-Warmer-Blanket-Manufacturers" element={<Patientwarmerblanketmanu />} />
        <Route path="/Air-Force-Warning-System-in-India" element={<Airforcewarmingsystem />} />
        <Route path="/Convection-Patient-Warmer-Blanket-Manufacturers" element={<Convectionpatientwarmerblanket />} />
        <Route path="/Patient-Warming-System-Manufacturers" element={<Systemmanufactures />} />
        <Route path="/Hypothermia-Prevention-Machine-Manufacturers" element={<Hypothermiaprevention />} />
        <Route path="/Patient-Warming-Machine-Manufacturers-in-India" element={<Patientwarmingmachinemanufacures />} />
        <Route path="/3M-Bair-Hugger-Warming-Blanket" element={<Bairhuggerwarming />} />
        <Route path="/Bair-Hugger-Warming-Machine-Manufacturer" element={<Bairhuggerwarmingmachine />} />
        <Route path="/Thermal-Warming-System-for-Patients-in-India" element={<Thermalwarmingsystem />} />
        <Route path="/Cocoon-Convective-Patient-Warming-System" element={<Cooconwarming />} />
        <Route path="/Air-Warmer-Machine-Manufacturers-in-India" element={<Airwarmermachinemanufacturesinindian />} />
        <Route path="/Mistral-Air-Blanket-Warmer-Machine" element={<Mistralairblanketwarmer />} />
        <Route path="/Mistral-Air-Plus-Service-Warmer-Machine" element={<Mistralairplusservice />} />



<Route path="/Patient-Warming-System" element={<Patientionwarmingsystem />} />
<Route path="/Patient-Warming-Devices" element={<Patientwarminfdevice />} />
<Route path="/Patient-Warming-Blanket" element={<Patientionwarmingblanket />} />
<Route path="/Patient-Warming-Machine" element={<Patientionwarmingmachine />} />
<Route path="/Patient-Warming-Mattress" element={<Patientionwarmingmattress />} />
<Route path="/Patient-Warming-System-Manufacturers-in-India" element={<Patientionwarmingsystemmanufacture />} />
<Route path="/Patient-Warming-Checklist" element={<Patientionwarmingchecklist />} />

      </Routes>

      <Footer />
    </Router>


  );
}

export default App;
